import React from "react";
import { Mail, Phone, MapPin, User } from "lucide-react";
import { KycDocRow, DOC_LABEL } from "./KycDocRow";

export function KycLawyerGroup({ group, busy, onView, onApprove, onReject, onOverride }) {
  const s = group.summary || {};
  const types = group.documents.map((d) => DOC_LABEL[d.doc_type] || d.doc_type);
  return (
    <li data-testid={`kyc-lawyer-group-${group.lawyer_id}`} className="bg-white">
      <div className="px-4 py-3 bg-slate-50/80 border-b border-slate-100 flex flex-wrap items-center gap-3">
        <div className="h-9 w-9 rounded-xl bg-[#0A2540] text-[#D4AF37] flex items-center justify-center shrink-0">
          <User size={16} />
        </div>
        <div className="flex-1 min-w-[240px]">
          <p className="font-bold text-[#0A2540]" data-testid={`kyc-lawyer-name-${group.lawyer_id}`}>
            {group.lawyer_name || group.lawyer_email || group.lawyer_id}
          </p>
          <p className="text-xs text-slate-500 flex flex-wrap items-center gap-x-3 gap-y-0.5">
            {group.lawyer_email && <span className="flex items-center gap-1"><Mail size={10} />{group.lawyer_email}</span>}
            {group.lawyer_phone && <span className="flex items-center gap-1"><Phone size={10} />{group.lawyer_phone}</span>}
            {group.lawyer_city && <span className="flex items-center gap-1"><MapPin size={10} />{group.lawyer_city}</span>}
          </p>
          <p className="text-xs text-slate-500 mt-0.5" data-testid={`kyc-lawyer-doccount-${group.lawyer_id}`}>
            <strong>{group.doc_count}</strong> document{group.doc_count === 1 ? "" : "s"} in this view · {types.join(" • ")}
          </p>
        </div>
        <div className="flex items-center gap-2 text-[11px] font-bold" data-testid={`kyc-lawyer-summary-${group.lawyer_id}`}>
          <span className="px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-800" data-testid={`kyc-summary-approved-${group.lawyer_id}`}>✓ {s.approved || 0} Approved</span>
          <span className="px-2 py-0.5 rounded-full bg-amber-100 text-amber-800" data-testid={`kyc-summary-pending-${group.lawyer_id}`}>● {s.pending_review || 0} Pending</span>
          <span className="px-2 py-0.5 rounded-full bg-rose-100 text-rose-800" data-testid={`kyc-summary-rejected-${group.lawyer_id}`}>✕ {s.rejected || 0} Rejected</span>
        </div>
      </div>
      <ul className="divide-y divide-slate-100">
        {group.documents.map((d) => (
          <KycDocRow key={d.id} item={{ ...d, lawyer_id: group.lawyer_id }} busy={busy}
            onView={onView} onApprove={onApprove} onReject={onReject} onOverride={onOverride} />
        ))}
      </ul>
    </li>
  );
}
